import { SkillsLessonByTypeQuery$data } from '../graphQLOperations/__generated__/SkillsLessonByTypeQuery.graphql';

export const TEACHER_LED_TYPE_ID = 'LessonTypeNode:11';

export interface TlrFile {
  url: string;
  name: string;
}

export interface TeacherLedFiles {
  slides: TlrFile | null;
  guide: TlrFile | null;
}

const isPptx = (url: string) => url.split('?')[0].toLowerCase().endsWith('.pptx');

export const fileExtension = (url: string, fallback: string) =>
  /\.([a-z0-9]+)$/i.exec(url.split('?')[0])?.[1]?.toLowerCase() ?? fallback;

export const pickTeacherLedFiles = (lessonsQueryData?: SkillsLessonByTypeQuery$data | null): TeacherLedFiles | null => {
  let slides: TlrFile | null = null;
  let guide: TlrFile | null = null;

  lessonsQueryData?.lessonSkills?.nodes?.forEach(node => {
    const lesson = node.lesson;
    if (lesson?.type?.id !== TEACHER_LED_TYPE_ID || !lesson.url) return;
    const file = { url: lesson.url, name: lesson.name || 'Teacher-Led Lesson' };
    if (isPptx(lesson.url)) {
      slides = slides ?? file;
    } else {
      guide = guide ?? file;
    }
  });

  return slides || guide ? { slides, guide } : null;
};
